import React from 'react';
import FairItem from './FairItem.jsx';

class ListFair extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <section className="fair-list-content">
        <h2 className='fair-list-title'>{this.props.title}</h2>
        <div className='fair-list-wrap'>
        {
          this.props.data.map((item, i) => {
            return(
              <FairItem {...item} key={i} enableAddProduct={this.props.enableAddProduct}/>
            )
          })
        }
        </div>
      </section>
    );
  }
}

ListFair.defaultProps={
  enableAddProduct: true,
  data: []
}

export default ListFair;


// WEBPACK FOOTER //
// ./components/my-business/sub-view/fair/ListFair.jsx